import { Button, Form, FormProps, Input, Modal } from 'antd'
import { FC, useState } from 'react'
import TextArea from 'antd/es/input/TextArea'
import { ModuleExerciseDto, ModulesDto } from '../../../shared/types/api'
import * as API_COURSES from '../../../shared/http/courses'


interface AddAICardListDialogProps {
    isOpen: boolean,
    close: () => void,
    cModule: ModulesDto,
    addExercise: (ex: ModuleExerciseDto) => void
}

const CreateCourseExampleDialog: FC<AddAICardListDialogProps> = ({ isOpen, close, addExercise, cModule }) => {

    const [loading, setLoading] = useState<boolean>(false)
    const [form] = Form.useForm()
    const [isValid, setIsValid] = useState(false)

    const handleFormChange = () => {
        const hasErrors = form
            .getFieldsError()
            .some(({ errors }) => errors.length > 0)
        setIsValid(!hasErrors)
    }

    type FieldType = {
        title?: string;
        text?: string;
        description?: string;
    };

    const onFinish: FormProps<FieldType>['onFinish'] = (values) => {
        setLoading(true)
        const ex =
            {
                type: 'EXAMPLE', moduleId: cModule.id, data:
                    {
                        title: values.title,
                        text: values.text,
                        description: values.description
                    }
            }

        API_COURSES.addExampleExercise(ex as ModuleExerciseDto).then(resp => {
            addExercise(resp as ModuleExerciseDto)
        }).finally(() => {
            setLoading(false)
            clearAndClose()
        })
    }


    const clearAndClose = () => {
        setIsValid(false)
        form.resetFields()
        close()
    }

    return (
        <Modal title='Создание теста в курсе'
               onCancel={clearAndClose}
               footer={[]}
               open={isOpen}>
            <Form
                onValuesChange={handleFormChange}
                form={form}
                name='basic'
                labelCol={{ span: 24 }}
                initialValues={{ remember: true }}
                autoComplete='off'
                onFinish={onFinish}
            >

                <Form.Item<FieldType>
                    name='title'
                    rules={[{ required: true, message: 'Поле обязательно к заполнению' }]}
                    label={'Заголовок'}
                >
                    <Input />

                </Form.Item>

                <Form.Item<FieldType>
                    name='text'
                    label={'Пример'}
                    rules={[{ required: true, message: 'Поле обязательно к заполнению' }]}
                >
                    <TextArea maxLength={600} rows={2}

                              placeholder={'Текст'} />

                </Form.Item>

                <Form.Item<FieldType>
                    name='description'
                    label={'Описание/Перевод'}
                >
                    <TextArea maxLength={600} rows={2}
                              placeholder={'Описание/Перевод'} />

                </Form.Item>


                <Form.Item wrapperCol={{ offset: 9, span: 8 }}>
                    <Button disabled={!isValid} loading={loading} type='primary'
                            htmlType='submit'>
                        Добавить
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default CreateCourseExampleDialog
